import AuthKit from "./AuthKit";

export default class {
  constructor() {
    this.authKit = new AuthKit();
    this.url = "/cms/"
  }

  async getPageList(event_slug) {
    const url = `${this.url}${event_slug}/pages/`;
    const response = await this.authKit.doGet(url);
    return response.data;
  }

  async getMainPage(event_slug) {
    const url = `${this.url}${event_slug}/main-page/`;
    const response = await this.authKit.doGet(url);
    return response.data;
  }

  async getPageDetail(event_slug, page_slug) {
    const url = `${this.url}${event_slug}/pages/${page_slug}/`;
    const response = await this.authKit.doGet(url);
    return response.data;
  }

  async getPageActionPoints(event_slug, page_slug) {
    const url = `${this.url}${event_slug}/pages/${page_slug}/action-points/`;
    const response = await this.authKit.doGet(url);
    return response.data;
  }

}
